import { createAction, props } from '@ngrx/store';

import { FundStats } from '../models/fund-stats.interface';

export const upsertFundStats = createAction(
	'UPSERT_MANY_FUNDSTATS',
	props<{ payload: FundStats[] }>()
);

export const upsertFundStatsCompare = createAction(
	'UPSERT_MANY_FUNDSTATSCOMPARE',
	props<{ payload: FundStats[] }>()
);
